import Rectangle from "./Rectangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import Area from "./Area";

export default class Egg extends AbstractShape {
	static NAME = "egg";

	constructor( width, height ) {
		super();

		this.width = width;
		this.height = height;
	}

	get_name() {
		return Egg.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.width, this.height );
	}

	// Formula beased on: https://rechneronline.de/pi/egg-profile.php
	get_circumference() {
		const a = this.width.in_mm() / 2;
		const h1 = ( this.height.in_mm() / 3 ) * 2; // first half height
		const h2 = this.height.in_mm() / 3; // second half height

		// Calculate the constants κ and λ
		const kappa = ( a - h1 ) / ( a + h1 );
		const lambda = ( a - h2 ) / ( a + h2 );

		// Helper function to calculate the term inside the formula
		function ellipseTerm( a, h, k ) {
			return ( a + h ) * ( 1 + ( 3 * Math.pow( k, 2 ) ) / ( 10 + Math.sqrt( 4 - 3 * Math.pow( k, 2 ) ) ) );
		}

		const p = Math.PI / 2 * ( ellipseTerm( a, h1, kappa ) + ellipseTerm( a, h2, lambda ) );
		return new Length( p );
	}

	get_width() {
		return this.width;
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		return {
			width: maximum_rectangle.get_longest_side(),
			height: maximum_rectangle.get_shortest_side()
		};
	}

	get_dimension_keys() {
		return [ "width", "height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height: this.height.in_mm()
		};
	}

	get_area() {
		const a = this.width.in_mm() / 2;
		const b = this.height.in_mm() / 2;

		return new Area( Math.PI * a * b );
	}

	static deserialize_primitives( primitives ) {
		return new Egg( new Length( primitives.width ), new Length( primitives.height ) );
	}
}
